import { Fragment, ReactNode } from "react";
import { Box } from "@mui/material";
import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { EntityTemplateField } from "../EntityTemplate.types.ts";
import { TemplateStepFieldGroup } from "./groupFieldsByTemplateStep.ts";

export interface TemplateStepFieldsProps {
    groups: Array<TemplateStepFieldGroup>;
    renderField: (field: EntityTemplateField) => ReactNode;
    /** Theme spacing below each field. Zero when what renderField returns reserves its own room below the field. */
    fieldSpacing?: number;
}

function TemplateStepFields({ groups, renderField, fieldSpacing = 2 }: TemplateStepFieldsProps) {
    // Every template asks for the same fixed creation fields (the name, plus country for a legal entity), so a
    // heading above only those just repeats the entity type. The steps earn their headings once the template
    // asks for something of its own.
    const showStepHeadings = groups.flatMap((group) => group.fields).some((field) => !isFixedCreationField(field));

    return (
        <>
            {groups.map((group) => (
                <Fragment key={group.stepId}>
                    {showStepHeadings && <DotLegalHeader headerStyle="small">{group.stepName}</DotLegalHeader>}
                    {group.fields.map((field) => (
                        <Box key={field.id} sx={{ marginBottom: fieldSpacing }}>
                            {renderField(field)}
                        </Box>
                    ))}
                </Fragment>
            ))}
        </>
    );
}

function isFixedCreationField(field: EntityTemplateField) {
    return field.requiredAtCreation && field.requiredAtCreationDisabled;
}

export default TemplateStepFields;
